module.exports = __webpack_public_path__ + "static/media/image2.81ca3a5d.png";